import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../app.service';
import translateJson from "../../../../translate.json";


@Component({
  selector: 'error-comp',   
  templateUrl: './error.component.html',
  providers: [AppService],
  styleUrls: ['./error.component.css']
})
export class ErrorComponent {
  	
  	seconds: any;
    private i18 = translateJson.i18;

    constructor(private appService: AppService, private router: Router) { 
    	this.countdown();
    	this.seconds = 10;
    }


    countdown() {
    	this.seconds = this.seconds - 1;

    	if(this.seconds < 0) {
    		this.router.navigate(['/']);
    	} else {
    		window.setTimeout("countdown", 1000);
    	}
	}

    redirect() {
        this.appService.setRoute("/");
    }
}
